import { frontendConfig, IFrontendConfiguration, AppStage as AppStageType, APP_STAGE } from '@cmctechnology/webinvest-constants';

// TODO: Remove this once package has been updated in all modules
export interface IConfiguration extends IFrontendConfiguration {}
export type AppStage = AppStageType;
export const devConfig: IConfiguration = frontendConfig.development;
export const stagingConfig: IConfiguration = frontendConfig.staging;
export const nfrConfig: IConfiguration = frontendConfig.nfr;
export const prodConfig: IConfiguration = frontendConfig.production;

export const configs = frontendConfig;

let envConfig: IConfiguration = devConfig;

export const setConfig = (config: IConfiguration) => {
  envConfig = config ?? envConfig;
};

export const getConfig = () => {
  return envConfig;
};

export const initConfig = (appStage: AppStage) => {
  let currentEnv = appStage;
  if (appStage === APP_STAGE.Staging || appStage === APP_STAGE.Dev) {
    // Determine environment based on host
    const host = window.location.host.toLowerCase();
    currentEnv =
      (Object.keys(configs) as AppStage[]).find((key) => configs[key].hostUrl.includes(host) || configs[key].stockbrokingUrl.includes(host)) ?? appStage;
  }
  setConfig(configs[currentEnv]);
};
